export const noteMap = {
  DealNote: 'Deal',
} as const
